export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12881.c06fc0da.jpg";